import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { digits, email, length, required, integer } from 'vee-validate/dist/rules'
import { lineBasicIdValidator, startWithAt, premiumIdvalidator, citizenIdValidator, decimals, maximumSizeFile } from '@/utils/validator'
import { calculateMessageAmount } from '@/utils/calculator'

const VeeValidatePlugin = {
  install (Vue) {
    Vue.component('ValidationProvider', ValidationProvider)
    Vue.component('ValidationObserver', ValidationObserver)
    extend('email', { ...email, message: 'กรุณากรอก {_field_} ให้ถูกต้อง' })
    extend('length', { ...length, message: 'กรุณากรอก {_field_} ให้ครบทั้ง {length} หลัก' })
    extend('integer', { ...integer, message: '{_field_} ต้องเป็นตัวเลขเท่านั้น' })
    extend('required', { ...required, message: 'กรุณากรอก {_field_}' })
    extend('paymenttype', { ...required, message: 'กรุณาเลือก{_field_}' })
    extend('fileUpload', { ...required, message: 'กรุณาอัพโหลดหลักฐานการชำระที่มีนามสกุลไฟล์เป็น jpg, png, pdf และมีขนาดไฟล์ไม่เกิน 10mb' })
    extend('maximumSizeFile', {
      validate: (value, { size }) => maximumSizeFile(value, size),
      message: 'กรุณาอัพโหลดหลักฐานการชำระที่มีนามสกุลไฟล์เป็น jpg, png, pdf และมีขนาดไฟล์ไม่เกิน {size}mb',
      params: ['size']
    })
    extend('digits', { ...digits, message: 'กรุณากรอก {_field_} ให้ครบ {length} หลัก' })
    extend('decimals', {
      validate: (value, { length: decimalsLength }) => decimals(value, decimalsLength),
      message: '{_field_} ต้องเป็นทศนิยม {length} เท่านั้น',
      params: ['length']
    })
    extend('lineBasicId', {
      validate: lineBasicIdValidator,
      message: 'กรุณากรอก {_field_} ให้ถูกต้อง'
    })
    extend('newArrayItem', {
      validate: (value, array) => !array.includes(value),
      message: 'คุณมี {_field_} นี้อยู่แล้ว '
    })
    extend('startWithAt', {
      validate: startWithAt,
      message: 'กรุณากรอก {_field_} ให้ถูกต้อง (พิมพ์ @ เป็นตัวแรก)'
    })
    extend('premiumId', {
      validate: premiumIdvalidator,
      message: 'ท่านกรอกชื่อ Premium ID ไม่ถูกต้อง กรุณาตรวจสอบเงื่อนไขการตั้งชื่ออีกครั้ง'
    })
    extend('additionalMessage', {
      validate: (value, { messageProduct }) => calculateMessageAmount(value, messageProduct) >= 1000,
      message: 'ราคารวม ที่ซื้อต้องมีขั้นต่ำ 1,000 บาท',
      params: ['messageProduct']
    })

    extend('citizenId', {
      validate: (value, { isJuristicCustomer }) => citizenIdValidator(value, isJuristicCustomer),
      message: 'กรุณากรอก {_field_} ครบทั้ง 13 หลักให้ถูกต้อง',
      params: ['isJuristicCustomer']
    })
  }
}

export default VeeValidatePlugin
